<template>
  <div id="TheFooter">
    <footer class="footer node-18">
      <small>
        Rebtel © Copyright {{ year }}
      </small>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'TheFooter',
  computed: {
    year () {
      return new Date().getFullYear()
    }
  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheFooter.vue